import { useEffect } from "react";
import { centralUrl } from "../../lib/hosts";

/**
 * Away from a workspace the page can't show: to the person's list of workspaces on the central host,
 * which signs them in first when they aren't. Never to `/` on this host, which is this workspace's
 * console again.
 */
export function ToWorkspaces() {
  useEffect(() => {
    window.location.replace(centralUrl("/admin"));
  }, []);
  return null;
}
